export default {
    general: {
        show_password: 'Prikaži geslo',
        hide_password: 'Skrij geslo',
        add: 'Dodaj',
        edit: 'Uredi',
        cancel: 'Prekliči',
        save: 'Shrani',
        delete: 'Izbriši',
        search: 'Išči',
        close: 'Zapri',
        confirm: 'Potrdi',
        back: 'Nazaj',
        actions: 'Dejanja',
        yes: 'Da',
        no: 'Ne',
        loading: 'Nalaganje …',
        select: 'Izberi',
        preview: 'Predogled',
        download: 'Prenesi',
    },
    errors: {
        generic_error: 'Prišlo je do napake',
        load_data: 'Pri nalaganju podatkov je prišlo do napake',
        on_add: 'Pri dodajanju je prišlo do napake',
        on_edit: 'Pri urejanju je prišlo do napake',
        on_delete: 'Pri brisanju je prišlo do napake',
        on_sort: 'Pri sortiranju je prišlo do napake',
        on_logout: 'Pri odjavi je prišlo do napake',
        no_access: 'Nimate dostopa',
    },
    api_errors: {
        internal_server_error: 'Neznana notranja napaka strežnika',
        invalid_data: 'Prejeti so bili neveljavni podatki',
        not_found: 'Ni najdeno',
        unauthorized: 'Nimate dovoljenja za to dejanje',
        invalid_password: 'Geslo ni pravilno',
        invalid_email: 'Neveljaven e-poštni naslov',
        invalid_email_or_password: 'E-pošta ali geslo ni pravilno',
        invalid_file_type: 'Zapis dokumenta ni pravilen',
        invalid_captcha: 'Neveljavna captcha',
        forgotten_password_expired: 'Zahteva za pozabljeno geslo je potekla',
        invalid_bill_password: 'Neveljavno geslo iz položnice',
        user_exists_by_email: 'Uporabnik s tem e-poštnim naslovom že obstaja',
        user_exists_by_code_payer: 'Uporabnik s to šifro plačnika že obstaja',
        no_code_payer: 'Šifra plačnika ne obstaja',
        manager_missing: 'Manjkajo podatki upravitelja',
        user_not_connected_to_manager: 'Uporabnik ni povezan z upravnikom',
    },
    success: {
        add: 'Dodajanje je bilo uspešno',
        edit: 'Urejanje je bilo uspešno',
        delete: 'Brisanje je bilo uspešno',
        sort: 'Sortiranje je bilo uspešno',
    },
    confirm: {
        default: 'Ste prepričani, da želite nadaljevati?',
        delete_row: 'Ste prepričani, da želite izbrisati {name}',
    },
    validation: {
        required: 'To polje je obvezno',
        email: 'Neveljaven e-poštni naslov',
        min_length: 'Vnesite vsaj {min} znakov',
        at_least_one_uppercase: 'Geslo mora vsebovati vsaj eno veliko črko',
        at_least_one_digit: 'Geslo mora vsebovati vsaj eno številko',
        passwords_must_match: 'Gesli se ne ujemata',
    },
    navigation: {
        menu: 'Meni',
        users: 'Uporabniki',
        partners: 'Partnerji',
        depositories: 'Vložišča',
        bulletin_board: 'Oglasna deska',
        faq: 'Pogosta vprašanja',
        allowed_pages: 'Dovoljene strani',
        change_password: 'Spremeni geslo',
        logout: 'Odjava',
    },
    footer: {
        all_rights_reserved: 'Vse pravice pridržane',
    },
    manager: {
        label: 'Upravnik',
        search: 'Išči upravnika …',
        no_results: 'Ni zadetkov',
        switch_success: 'Upravnik je uspešno zamenjan',
        switch_error: 'Prišlo je do napake pri menjavi upravnika',
    },
    table: {
        empty: 'Ni podatkov za prikaz',
        reload: 'Osveži',
        clear_filters: 'Počisti filtre',
        search_by: 'Išči po {field}',
        pick_option: 'Izberi možnost',
        pick_date: 'Izberi datum',
        page_report: '{first} - {last} od {total}',
    },
    editor: {
        images_not_allowed: 'Vstavljanje slik ni dovoljeno!',
        audio_not_allowed: 'Vstavljanje zvoka ni dovoljeno!',
        video_not_allowed: 'Vstavljanje videa ni dovoljeno!',
    },
    upload: {
        file: 'Datoteka',
        files_and_photos: 'Datoteke in fotografije',
        drop_hint: 'Povlecite in spustite datoteke za nalaganje.',
        uploaded: 'Naloženo',
        type_not_allowed: 'Nekatere datoteke niso bile dodane, ker njihov zapis ni dovoljen',
        clear: 'Odstrani',
    },
    login: {
        email: 'E-pošta',
        password: 'Geslo',
        remember_me: 'Zapomni si me',
        forgotten_password: 'Pozabljeno geslo?',
        submit: 'Vstopi',
        error: 'Pri prijavi je prišlo do napake',
    },
    change_password: {
        title: 'Spremeni geslo',
        current: 'Trenutno geslo',
        new: 'Novo geslo',
        repeat: 'Potrdi geslo',
        submit: 'Spremeni geslo',
        success: 'Geslo je bilo uspešno spremenjeno',
        error: 'Pri spremembi gesla je prišlo do napake',
    },
    forgotten_password: {
        title: 'Pozabljeno geslo',
        intro: 'Spodaj vnesite svoj e-poštni naslov in poslali vam bomo navodila za ponastavitev vašega gesla.',
        submit: 'Ponastavi geslo',
        sent_title: 'Navodila za ponastavitev gesla poslana!',
        sent_body: 'Na vpisan e-poštni naslov so bila uspešno poslana navodila, kako ponastaviti geslo. Geslo je potrebno ponastaviti v 24 urah.',
        back_to_login: 'Nazaj na prijavo',
        captcha_error: 'Pri reševanju captche je prišlo do napake. Prosimo osvežite stran.',
        send_error: 'Pri pošiljanju e-pošte je prišlo do napake',
    },
    reset_password: {
        title: 'Ponastavite geslo',
        intro: 'Spodaj vnesite novo geslo.',
        new: 'Novo geslo',
        repeat: 'Ponovite geslo',
        submit: 'Ponastavi geslo',
        success: 'Ponastavitev gesla je bila uspešna!',
        error: 'Pri ponastavitvi gesla je prišlo do napake',
    },
    not_found: {
        title: 'Stran ni najdena!',
        subtitle: 'Iskane strani žal nismo našli.',
        back_home: 'Nazaj na začetno stran',
    },
    user: {
        title: 'Uporabniki',
        add: 'Dodaj uporabnika',
        firstname: 'Ime',
        lastname: 'Priimek',
        email: 'E-pošta',
        code_payer: 'Šifra plačnika',
        address: 'Naslov',
        post_code: 'Pošta',
        city: 'Kraj',
        post_and_city: 'Pošta in kraj',
        password: 'Geslo',
        password_help: 'Geslo mora biti dolgo vsaj 8 znakov ter vsebovati vsaj eno veliko črko in eno številko.',
        bill_password: 'Geslo iz položnice',
        bill_password_help: 'Geslo najdete na računu.',
        generate: 'Generiraj',
        check_email: 'Preveri e-pošto uporabnika',
        enter_valid_email: 'Vnesite pravilen e-poštni naslov',
        change_password: 'Spremeni geslo',
        change_user_password: 'Spremeni geslo uporabnika',
        switch_to: 'Preklopi',
        switch_error: 'Prišlo je do napake pri preklopu na uporabnika',
        export: 'Izvoz uporabnikov',
        export_error: 'Prišlo je do napake pri izvozu uporabnikov',
        unlink: 'Odpoveži',
        unlink_confirm: 'Ali ste prepričani, da želite odpovezati uporabnika: {firstname} {lastname} - {code_payer}?',
        unlink_success: 'Uporabnik je uspešno odpovezan',
        unlink_error: 'Prišlo je do napake pri odpovezavi uporabnika',
    },
    partner: {
        title: 'Partnerji',
        name: 'Naziv',
        code: 'Šifra',
        address: 'Naslov',
        post_code: 'Pošta',
        city: 'Kraj',
        password: 'Geslo',
        password_set: 'Geslo je nastavljeno',
        password_not_set: 'Geslo ni nastavljeno',
        switch_to: 'Preklopi',
        switch_error: 'Prišlo je do napake pri preklopu na partnerja',
    },
    depository: {
        title: 'Vložišča',
        add: 'Dodaj vložišče',
        base: 'Osnovno vložišče',
        display_name: 'Prikazan naziv',
        content: 'Vsebina vložišča',
        content_of: 'Vsebina vložišča: {name}',
        delete_name: 'vložišče: {name}?',
        filter_by_building: 'Filtriraj po objektu',
        document_name: 'Naziv',
        subject: 'Zadeva',
        partner: 'Partner',
        document_date: 'Datum dokumenta',
        format: 'Format',
        no_file: 'Dokument nima datoteke',
        download_error: 'Prišlo je do napake pri prenosu dokumenta',
    },
    bulletin: {
        title: 'Oglasna deska',
        add: 'Dodaj obvestilo',
        edit: 'Uredi obvestilo',
        name: 'Naslov',
        content: 'Vsebina',
        buildings: 'Objekti',
        pick_buildings: 'Izberi objekte',
        limit_to_buildings: 'Omejitev na objekte',
        limited_to_building: 'Omejeno na objekt',
        active: 'Aktivno obvestilo',
        delete_name: 'obvestilo: {title}?',
    },
    faq: {
        title: 'Pogosta vprašanja',
        add: 'Dodaj vprašanje',
        position: 'Vrstni red',
        question: 'Vprašanje',
        answer: 'Odgovor',
        delete_name: 'vprašanje: {question}?',
    },
    allowed_pages: {
        title: 'Dovoljene strani',
        page_name: 'Naziv strani',
        pages: {
            regular_billing: 'Redni obračun',
            reserve_fund_billing: 'Obračun rezervni sklad',
            open_items: 'Odprte postavke',
            card_traffic: 'Kartica obračunov s plačili',
            readings: 'Obračuni toplote',
            reserve_fund: 'Rezervni sklad',
            voluntary_fund: 'Prostovoljni sklad',
            reserved_fund_debtors: 'Dolžniki rezervnega sklada',
            reserved_fund_postings: 'Promet knjižb rezervnega sklada',
            manager_documents: 'Dokumenti upravnika',
            supplier_documents: 'Dokumenti dobaviteljev',
            notifications: 'Obvestila',
            your_units: 'Vaše enote',
            bulletin_board: 'Oglasna deska',
            faq: 'Pogosta vprašanja',
            contractors: 'Izvajalci',
            cost_specification: 'Specifikacija stroškov',
            tenants: 'Najemniki',
            registered_people_and_dogs: 'Prijavljena št. oseb in psov',
            insurance_contracts: 'Zavarovalne pogodbe',
        },
    },
}
